import axios from './authService';
import API_ENDPOINTS from '../config/apiConfig';

export const analyzeTest = async (testId) => {
  const response = await axios.post(API_ENDPOINTS.SUMMARIZE_FLOW(testId));
  return response.data;
};

export const analyzeRegression = async (regressionId) => {
  const response = await axios.post(API_ENDPOINTS.SUMMARIZE_REGRESSION(regressionId));
  return response.data;
};
